<template>
  <div class="i-switch">
    <span class="label-txt">{{ label }}</span>
    <label class="i-switch" :class="color + '--text'">
      <input type="radio" name="xx" v-model="mutableValue" @input="$emit('input', $event.target.checked)">
      <span class="slider"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'i-switch',
  props: {
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  data: function () {
    return {
      mutableValue: this.$vnode.data.model ? this.$vnode.data.model.value : false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/radioSwitch.vue